<template>
  <div class="mt-4">
    <div
        class="checkboxItem mt-2"
        v-for="(item, i) in items"
        :id="item.id"
        :key="i"
        @click="setCheckbox(item.id)"
        style="cursor: pointer"
        :class="[
          isSelected(item.id) && 'activeOption',
          isSelected(item.id) && isOtherOption(item) && 'checkboxItem--withText'
        ]"
    >
      <div class="d-flex flex-grow-1" style="width: 100%">
        <div>
          <v-checkbox
              @click.stop="setCheckbox(item.id)"
              v-model="checkboxSelected"
              :value="item.id"
              hide-details
              style="margin-top: -6px"
              color="primary"
          ></v-checkbox>
        </div>
        <div class="mx-2 text-right">
          <template v-if="$vuetify.rtl">
            {{ item.text }}
          </template>
          <template v-else>
            {{ item.en_text }}
          </template>
        </div>
      </div>
      <div
          v-if="isSelected(item.id) && isOtherOption(item)"
          class="otherTextField"
          @click.stop
      >
        <v-text-field
            v-model="otherTexts[item.id]"
            :placeholder="$t('matchMaking.description')"
            outlined
            dense
            hide-details
            @click.stop
        />
      </div>
    </div>
    <v-btn
        class="confirmBtn"
        id="confirm_btn"
        color="#3CBE8B"
        elevation="0"
        block
        @click="changes"
        v-if="$vuetify.breakpoint.lgAndUp"
    >
      {{ $t('matchMaking.buttons.submit') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    language: {
      default: 'fa'
    },
    callChangeInOption: Boolean,
    initialAnswers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkboxSelected: [],
      otherTexts: {},
    }
  },
  mounted() {
    this.applyInitialAnswers()
  },
  methods: {
    isSelected(id) {
      return this.checkboxSelected.includes(id)
    },
    isOtherOption(item) {
      return (item.text && item.text.includes('سایر'))
          || (item.en_text && item.en_text.toLowerCase().includes('other'))
    },
    applyInitialAnswers() {
      if (!this.initialAnswers?.length) {
        return
      }
      this.checkboxSelected = this.initialAnswers
          .map((answer) => answer.question_option_id)
          .filter((id) => id != null)

      this.initialAnswers.forEach((answer) => {
        if (answer.question_option_id != null && answer.answer_text) {
          this.$set(this.otherTexts, answer.question_option_id, answer.answer_text)
        }
      })
    },
    setCheckbox(id) {
      if (this.isSelected(id)) {
        const index = this.checkboxSelected.findIndex((item) => item === id)
        this.checkboxSelected.splice(index, 1)
        const item = this.items.find((entry) => entry.id === id)
        if (item && this.isOtherOption(item)) {
          this.$delete(this.otherTexts, id)
        }
      } else {
        this.checkboxSelected.push(id)
      }
    },
    changes() {
      if (!this.checkboxSelected.length) {
        this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')})
        return
      }

      for (const id of this.checkboxSelected) {
        const item = this.items.find((entry) => entry.id === id)
        if (item && this.isOtherOption(item)) {
          const text = (this.otherTexts[id] || '').trim()
          if (!text) {
            this.$emitEvent('notify', {color: 'red', title: this.$t('matchMaking.pleaseAnswer')})
            return
          }
        }
      }

      this.$emit('answerHandler', this.checkboxSelected.map((id) => {
        const answer = {question_option_id: id}
        const item = this.items.find((entry) => entry.id === id)
        if (item && this.isOtherOption(item)) {
          answer.answer_text = this.otherTexts[id].trim()
        }
        return answer
      }))
    },
  },
  watch: {
    initialAnswers: {
      handler() {
        this.applyInitialAnswers()
      },
      deep: true,
    },
    callChangeInOption(val) {
      if (val) {
        this.changes()
      }
    },
  },
}
</script>

<style scoped>
.checkboxItem {
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px #E1E1E1;
  background: #FFF;
  cursor: pointer;
  margin-bottom: 13px;
}

.checkboxItem--withText {
  height: auto;
  min-height: 60px;
  align-items: stretch;
}

.otherTextField {
  width: 100%;
  margin-top: 8px;
}

.checkboxItem:hover {
  transition: all 0.3s;
  border-color: #39C990 !important;
}

.activeOption {
  border: 2px solid #39C990;
  box-shadow: none;
}
</style>
